import { Dispatch, ReactNode, SetStateAction } from 'react';
import { CorporatePartner } from '../../../../../../interfaces/CorporatePartner';
import {
    CertificateOfOrigin,
    CertificateOfOriginFormErrors
} from '../../../../../../interfaces/CertificateOfOrigin';
import { TransformedItems } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import FormFooter from '../../../common/FormFooter';
import StepOne from './StepOne';
import StepTwo from './StepTwo';

interface CertificateOriginMobileFormProps {
    updateField: (name: string, value: string | number) => void;
    payload: CertificateOfOrigin;
    corporatePartners: CorporatePartner[];
    loadingCorporatepartners: boolean;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
    errors: CertificateOfOriginFormErrors;
    quoteFields: TransformedItems[];
    updateQuoteField: (
        index: number,
        attributeName: keyof TransformedItems,
        attributeValue: TransformedItems[keyof TransformedItems]
    ) => void;
    removeQuoteField: (index: number) => void;
    addQuoteField: () => void;
    setSignatureUrlBase64: (value: string) => void;
    signatureUrlBase64: string;
    setSignatureUrlBase64Chamber: (value: string) => void;
    signatureUrlBase64Chamber: string;
    totalGrossWeight: number;
    activeStep: number;
    setActiveStep: (step: number) => void;
    onSaveOnlyAction?: () => void;
    showPreview: boolean;
    setShowPreview: (val: boolean) => void;
}

const CertificateOriginMobileForm = ({
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    addQuoteField,
    setSignatureUrlBase64,
    signatureUrlBase64,
    activeStep,
    setActiveStep,
    onSaveOnlyAction,
    showPreview,
    setShowPreview,
    setSignatureUrlBase64Chamber,
    signatureUrlBase64Chamber,
    totalGrossWeight
}: CertificateOriginMobileFormProps) => {
    const views: {
        [key: number]: ReactNode;
    } = {
        0: (
            <StepOne
                {...{
                    updateField,
                    payload,
                    corporatePartners,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    errors,
                    quoteFields,
                    updateQuoteField,
                    removeQuoteField,
                    addQuoteField
                }}
            />
        ),
        1: (
            <StepTwo
                {...{
                    updateField,
                    payload,
                    errors,
                    setSignatureUrlBase64,
                    signatureUrlBase64,
                    setSignatureUrlBase64Chamber,
                    signatureUrlBase64Chamber,
                    totalGrossWeight
                }}
            />
        )
    };

    return (
        <div className='lg:hidden pt-4'>
            {views[activeStep]}
            <FormFooter
                onContinue={() => {
                    setActiveStep(activeStep + 1);
                }}
                onSave={() => onSaveOnlyAction && onSaveOnlyAction()}
                onPreview={() => setShowPreview(!showPreview)}
                onGoBack={() => {
                    setActiveStep(activeStep - 1);
                }}
                steps={2}
                activeStep={activeStep}
                disabled={Object.values(payload).some(
                    (item) => item === undefined
                )}
            />
        </div>
    );
};

export default CertificateOriginMobileForm;
